<template lang="pug">
v-layout.pago-efectivo(column style="margin-left: auto;margin-right: auto;margin-top: 4em;width: 25em;")
  v-flex(style="margin-bottom: 1em !important;")
    span(style="font-size: 18px;color: #454A6C")
      b Formas de pago
  v-flex
    v-layout.select-credit-card(align-center justify-start row fill-height)
      v-flex
        v-radio-group.icons-radio-group(v-model="mediosDePago" :mandatory="false" @click="methodSelectPago")
          v-layout(column style="padding-bottom: 0.9em;border-bottom: 1px solid #C9C9C9;")
            v-flex
              v-layout(row)
                v-flex(style="max-width: 2.5em;")
                  v-radio.radio-credit-card(value="1" on-icon="check_circle" color="#0855CA")
                v-flex
                  span(style="font-size: 17px;color: #454A6C;") Tarjetas de crédito o débito
            v-flex(style="margin: 1em 0em;")
              v-layout
                v-flex(style="max-width: 2.5em;")
                v-flex.img-credit-card
                  v-img
                    img(:src="require('@/assets/icons-tarjeta-credito/icon-visa-logo.svg')")
                v-flex.img-credit-card
                  v-img
                    img(:src="require('@/assets/icons-tarjeta-credito/icon-mastercard-logo.svg')")
                v-flex.img-credit-card
                  v-img
                    img(:src="require('@/assets/icons-tarjeta-credito/icon-amex-logo.svg')")
                v-flex.img-credit-card
                  v-img
                    img(:src="require('@/assets/icons-tarjeta-credito/icon-diners-logo.svg')")
          v-layout(column v-show="pagoEfectivoProp" style="padding-top: 1.5em")
            v-flex
              v-layout(row)
                v-flex(style="max-width: 2.5em;")
                  v-radio.radio-credit-card(value="2" on-icon="check_circle" color="#0855CA")
                v-flex
                  span(style="font-size: 17px;color: #454A6C;") Pago efectivo
            v-flex
              v-layout(row style="padding: 0.7em 0em")
                v-flex(style="max-width: 2.5em;")
                v-flex
                  v-img
                    img(:src="require('@/assets/icons-tarjeta-credito/icon-pagoefectivo-logo.svg')")
            v-flex
              v-layout(row)
                v-flex(style="max-width: 2.5em;width: 100%;")
                v-flex(style="line-height: normal;")
                  span(style="font-size: 15px;color: #454A6C;") Realiza el pago en la entidad bancaria o agencia  de tu preferencia
                    b presentando tu código (CIP) PagoEfectivo
                    | dentro de las próximas 24 horas.
            v-flex
              v-layout(row style="margin:0.8em 0em")
                v-flex(style="max-width: 2.5em;width: 100%;")
                v-flex
                  a.link-pago-efectivo.text-forma-pago(@click="comoPagar" style="font-size: 15px;") Como funciona, bancos y agencias afiliadas
</template>

<script>
import {mapGetters} from 'vuex'
import Functionalities from '../../../interfaces/functionalities'

export default {
  props: [
    'pagoEfectivoProp'
  ],
  data () {
    return {
      mediosDePago: null
    }
  },
  methods: {
    methodSelectPago () {
      this.$emit('getMedioDePago', this.mediosDePago)
    },
    comoPagar () {
      this.$emit('formaDePago')
    }
  },
  computed: {
    ...mapGetters('user', ['functionsRules'])
  }
}
</script>
<style scoped>
@import './../../../assets/css/pago-efectivo/pagoEfectivoStyle.css';
</style>



// WEBPACK FOOTER //
// src/components/payment/pago-efectivo/PagoEfectivo.vue